/* Page to contain the Second Unit Home page */
import React, { useState } from "react"
import styles from "../../styles/Scene.module.css"
import btnStyles from "../../styles/Button.module.css"
import { useRedirect } from "../../hooks/Redirect"
import { Button } from "react-bootstrap"
import TopBox from "../../components/TopBox"
import { useHistory } from "react-router-dom"
import ExtraCrewInfo from "./crewinfo/ExtraCrewInfo"
import InfoCrew from "./InfoCrew"

const SecondCrew = () => {
  useRedirect()
  const history = useHistory()
  const [showInfo, setShowInfo] = useState(false)

  return (
    <div>
      <TopBox 
      second="2ND UNIT"
      title="Crew Info" />
      {/* add  */}
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-1`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Button
        className={`float-right py-0 mt-1 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowInfo((showInfo) => !showInfo)}
      >
        INFO
      </Button>
      {!showInfo ? "" : <InfoCrew />}
      <h3 className="text-center">2nd Unit - CrewInfo</h3>
      <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
      <ExtraCrewInfo/>
    </div>
  )
}

export default SecondCrew